import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {TiposConselhoModel, TiposConselhoPrimaryKey} from "../models/tipos-conselho.model";
import {CrudBaseService} from "./crud-base.service";

@Injectable({
  providedIn: 'root'
})
export class TiposConselhoService extends CrudBaseService<TiposConselhoModel> {

  constructor(http: HttpClient) {
    super(http, 'tipos-conselhos');
  }

  public getPk(id: TiposConselhoPrimaryKey): TiposConselhoPrimaryKey {
    return Object.assign(new TiposConselhoPrimaryKey(), id);
  }
}
